import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from '../actions/presence.actions';
import { GenesysCloudPresenceState as State, initialState } from '../genesys-cloud-presence.state';
import { SystemPresence, SystemPresenceType } from '../models/system-presence.model';
import { sortBy } from 'lodash';
import { ExtendedPresence, ExtendedPresenceState } from '../models/extended-presence.model';
import {
  selectAwayPresence,
  selectOnQueuePresence
} from 'common/store/genesys-cloud/presence/selectors/presence.selectors';

export const featureKey = 'genesysCloudPresence';

const reducer = createReducer(
  initialState(),
  on(Actions.systemPresencesLoaded, (state, { systemPresences }) => ({
    ...state,
    presences: toSortedExtendedPresences(systemPresences)
  })),
  on(Actions.updatePresenceSuccess, setActivePresenceBySystemPresenceId),
  on(Actions.getActualPresenceSuccess, setActivePresenceBySystemPresenceId)
);

export function genesysCloudPresenceReducer(state: State, action: Action): State {
  return reducer(state, action);
}

function toExtendedPresence(systemPresence: SystemPresence): ExtendedPresence {
  return {
    ...systemPresence,
    state: systemPresence.name === SystemPresenceType.OnQueue ? ExtendedPresenceState.Available : ExtendedPresenceState.Away
  };
}

function toSortedExtendedPresences(systemPresences: SystemPresence[]): ExtendedPresence[] {
  return sortBy(systemPresences.map(toExtendedPresence), ['state', 'name']);
}

function setActivePresenceBySystemPresenceId(state: State, { systemPresenceId }: { systemPresenceId: string }): State {
  const onQueuePresence = selectOnQueuePresence({ [featureKey]: state });
  const awayPresence = selectAwayPresence({ [featureKey]: state });

  return {
    ...state,
    active: onQueuePresence.id === systemPresenceId ? onQueuePresence : awayPresence
  };
}
